import { render } from "./resetPassword.vue?vue&type=template&id=2f5fec0a&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"

import "./resetPassword.vue?vue&type=style&index=0&id=2f5fec0a&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/raiseloans/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5fec0a"]])

export default __exports__